// Dashboard-specific constants
export const API_CONSTANTS = {
  SUCCESS_CODE: 0,
  RECORDS_NOT_FOUND_CODE: 2,
  // Default timezone for Provider Pay Request dashboard related APIs
  DEFAULT_TIMEZONE: "America/New_York",
  DEFAULT_SORT_NUMBER: 1,
  DEFAULT_SORT_ORDER_ASC: "ASC",
  DEFAULT_SORT_ORDER_DESC: "DESC",
};

export const DATE_FORMATS = {
  API_FORMAT: "YYYY-MM-DD HH:mm:ss",
  ISO_DATE_ONLY: "YYYY-MM-DD",
};

export const CHART_DEFAULTS = {
  DONUT_HOLE_SIZE: 40,
  CHART_HEIGHT: "180px",
  PRECISION_DECIMAL_PLACES: 3,
};

export const PERIOD_FILTERS = {
  PYTD: "PYTD",
  YTD: "YTD",
  QUARTERLY: "Quarterly",
  MONTHLY: "Monthly",
  WEEKLY: "Weekly",
  DAILY: "Daily",
};

export const EVENT_TYPES = {
  SHIFT: "shift",
  CME: "cme",
  ON_CALL: "on-call",
  LEADERSHIP: "leadership",
  MEDICAL_DIRECTORSHIP: "medical-directorship",
  CLINICAL_SERVICES: "clinical-services",
  WRVU: "wrvu",
  PAY_REQUEST: "pay-request",
};

export const CALENDAR_CONSTANTS = {
  DAYS_IN_GRID: 35,
  MILLISECONDS_IN_DAY: 24 * 60 * 60 * 1000,
};

export const SCROLL_AMOUNT = 100;

export const PayRequestDashboardConstant = {
  headerConfig: {
    title: "Provider Dashboard",
    id: "pay-request-dashboard",
  },

  periodFilters: [
    { text: "PYTD", value: "PYTD" },
    { text: "YTD", value: "YTD" },
    { text: "Quarterly", value: "Quarterly" },
    { text: "Monthly", value: "Monthly" },
    { text: "Weekly", value: "Weekly" },
    { text: "Daily", value: "Daily" },
  ],

  tabLabels: {
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
  },

  chartColors: {
    shifts: "#4CAF50",
    onCall: "#2196F3",
    cme: "#FF5722",
    leadership: "#9C27B0",
    medicalDirectorship: "#FF9800",
    clinicalServices: "#E91E63",
  },

  statusColors: {
    pending: "#2196F3",
    approved: "#4CAF50",
    rejected: "#f44336",
  },

  messages: {
    announcements: {
      pendingRequests: "You have 23 pending pay requests submitted in last 30 days. Please review them now.",
      moreInfoLink: "Click here for more info.",
    },
  },
};
